import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { ReactElement } from 'react'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  let tenantId = 'misc'
  const isLhc = properties?.club === 'lhc'

  if (tenant) {
    switch (tenant.name) {
      case '24 heures':
        tenantId = 'vqh'
        break
      case 'Tribune de Genève':
        tenantId = 'tdg'
        break
      case 'Le Matin Dimanche':
        tenantId = 'lmd'
        break
      case '20 minutes':
        tenantId = 'vmn'
        break
      default:
        tenantId = 'misc'
    }
  }

  const texts: { [key: string]: ReactElement } = {
    vqh: (
      <Text>
        Sponsorisé par{' '}
        <Link target='_blank' href='https://www.bcv.ch/'>
          Banque Cantonale Vaudoise <img src={require('./arrow.svg').default} />
        </Link>
      </Text>
    ),
    tdg: (
      <Text>
        Sponsorisé par{' '}
        <Link target='_blank' href='https://jeux.loro.ch/sports/hub/820803'>
          Loterie Romande <img src={require('./arrow.svg').default} />
        </Link>
      </Text>
    ),
    misc: (
      <Text>
        Sponsorisé par{' '}
        <Link target='_blank' href='https://jeux.loro.ch/sports/hub/820803'>
          Loterie Romande <img src={require('./arrow.svg').default} />
        </Link>
      </Text>
    ),
    lmd: (
      <Text>
        Sponsorisé par{' '}
        <Link target='_blank' href='https://jeux.loro.ch/sports/hub/820803'>
          Loterie Romande <img src={require('./arrow.svg').default} />
        </Link>
      </Text>
    ),
    vmn: (
      <Text>
        Sponsorisé par{' '}
        <Link target='_blank' href=''>
          Banque Cantonale Vaudoise <img src={require('./arrow.svg').default} />
        </Link>
      </Text>
    ),
  }

  const logos: { [key: string]: string } = {
    tdg: require('./loterie_romande.svg').default,
    misc: require('./loterie_romande.svg').default,
    vqh: isLhc ? require('./bcv-v2.png') : require('./bcv.svg').default,
  }

  return (
    <AppContainer $colorMode={colorMode}>
      <Container>
        <Content>
          <Logo style={{width: isLhc ? '100%' : '9rem'}} src={logos[tenantId]} />
          {texts[tenantId]}
        </Content>
        </Container>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;
  margin-bottom: 2rem;
`

const Link = styled.a`
color: var(--text-color);
text-decoration: none;
    padding: 0.2rem 0 0;
    background-image: linear-gradient(to right,var(--text-color) 0,var(--text-color) 10%);
    background-size: 100% 1px;
    background-position-y: 17px;
    background-repeat: repeat-x;
    background-position: bottom;
    white-space: nowrap;

    &:after {
      content: url(${require('./arrow.svg')});
      vertical-align: top;
      display: inline-block;
      margin-top: 0.1rem;
    }
}
`

const Text = styled.div`
  text-align: center;
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 280px;
`

const Logo = styled.img`
  display: block;
  width: 9rem;
  margin-bottom: 2rem;
`

export default MainComponent
